<template>
  <oxd-input-field
    type="select"
    :label="$t('time.project')"
    :options="options"
    required
  />
</template>

<script>
import {ref, onBeforeMount} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'ProjectDropdown',
  props: {
    excludeProjectIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  setup(props) {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/time/projects',
    );

    const loadProjects = () => {
      return new Promise((resolve) => {
        const params = {
          model: 'detailed',
          onlyAllowed: false,
          excludeProjectIds:
            props.excludeProjectIds.length > 0
              ? props.excludeProjectIds
              : undefined,
          status: true,
        };
        http.getAll(params).then(({data}) => {
          resolve(
            data.data.map((project) => {
              return {
                id: project.id,
                label: `${project.customer?.name} - ${project.name}`,
                _customer: project.customer,
                attendance: project.attendanceRequired,
              };
            }),
          );
        });
      });
    };

    onBeforeMount(() => {
      loadProjects().then((projects) => {
        options.value = projects;
      });
    });

    return {
      options,
      loadProjects,
    };
  },
};
</script>
